import React from 'react';
import Breadcrumbs from 'components/breadcrumb';
import Layout from '_metronic/layout/Layout';

import From from './form';
const breadcrumb = [
  { page: 'installer/car/wrappingNew', title: 'Automóvil' },
  {
    page: 'installer/car/wrappingNew',
    title: 'Nueva Garantía - Auto Wrap',
  },
];

export default () => (
  <Layout>
    <div className="kt-space-20" />
    <div className="row">
      <div className="col-12">
        <div className="kt-space-20" />
        <Breadcrumbs title="Automóvil" items={breadcrumb} />
        <div className="kt-space-20" />
      </div>
    </div>
    <div className="row">
      <div className="col-12">
        <From />
      </div>
    </div>
  </Layout>
);
